import type { AxiosRequestConfig } from 'axios';

import { axiosInstance } from '../axios-instance';

type RequestOptions = AxiosRequestConfig | undefined;

export interface ToolAccessUserWireDto {
  username?: string;
  displayName?: string;
  roleName?: string;
  grantedAt?: string;
  lastToolLoginOn?: string | null;
  isSystemAdmin?: boolean;
  allDatabases?: boolean;
  databaseNames?: string[];
}

export interface AssignToolRoleWireInput {
  roleName: string;
  allDatabases: boolean;
  databaseNames: string[];
}

/**
 * Omitted from published OpenAPI until TROC-168 ships; see `orval.config.ts`.
 */
export const getApiUserManagementV1ToolAccess = (options?: RequestOptions, signal?: AbortSignal) =>
  axiosInstance<ToolAccessUserWireDto[]>(
    { url: '/api/user-management/v1/tool-access', method: 'GET', signal },
    options
  );

export const postApiUserManagementV1ToolAccessUsernameRole = (
  username: string,
  assignToolRoleInput: AssignToolRoleWireInput,
  options?: RequestOptions
) =>
  axiosInstance<void>(
    {
      url: `/api/user-management/v1/tool-access/${encodeURIComponent(username)}/role`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: assignToolRoleInput
    },
    options
  );

export const deleteApiUserManagementV1ToolAccessUsername = (username: string, options?: RequestOptions) =>
  axiosInstance<void>(
    { url: `/api/user-management/v1/tool-access/${encodeURIComponent(username)}`, method: 'DELETE' },
    options
  );

export interface ToolAccessGrantCandidateWireDto {
  username?: string;
  displayName?: string;
  isEligible?: boolean;
  ineligibilityReason?: string | null;
}

export interface ToolAccessGrantCandidatesWireDto {
  candidates?: ToolAccessGrantCandidateWireDto[];
  activeDatabaseCount?: number;
  activeDatabaseNames?: string[];
  isComplete?: boolean;
  warningMessage?: string | null;
}

/**
 * TROC-234 — omitted from published OpenAPI until spec is regenerated.
 */
export const getApiUserManagementV1ToolAccessCandidates = (options?: RequestOptions, signal?: AbortSignal) =>
  axiosInstance<ToolAccessGrantCandidatesWireDto>(
    { url: '/api/user-management/v1/tool-access/candidates', method: 'GET', signal },
    options
  );
